export const CATEGORIES = [
  {
    name: "Origins & History",
    slug: "origins-and-history",
    color: "#5a1f24",
    title: "Tea Origins & History — The Tea List",
    description:
      "How tea travelled from Yunnan to the world: Shen Nong, the Silk Road, the East India Company and the stories that shaped every cup poured in Australia today.",
  },
  {
    name: "Types of Tea",
    slug: "types-of-tea",
    color: "#1e4a35",
    title: "Types of Tea: Black, Green, White, Oolong & Pu-erh — The Tea List",
    description:
      "Plain-English guides to every tea type — black, green, white, oolong, pu-erh and herbal — written for Australian and New Zealand tea drinkers.",
  },
  {
    name: "Global Tea Regions",
    slug: "global-tea-regions",
    color: "#1f2d4e",
    title: "Global Tea Regions: Ceylon, Darjeeling, Assam, Uji & More — The Tea List",
    description:
      "Single-region deep dives into Sri Lanka, Darjeeling, Assam, Yunnan, Taiwan, Japan and beyond — plus what's growing in Australia and New Zealand.",
  },
  {
    name: "Brewing & The Art of Tasting",
    slug: "brewing-and-the-art-of-tasting",
    color: "#6b7d5c",
    title: "Brewing Guides & Tasting Notes — The Tea List",
    description:
      "Water temperature, leaf ratios, steep times and gongfu technique — practical brewing guides for Australian kitchens, from kettle to cup.",
  },
  {
    name: "Curious Tea Stories",
    slug: "curious-tea-stories",
    color: "#1b1b1b",
    title: "Curious Tea Stories — The Tea List",
    description:
      "The strange, unlikely and true corners of tea culture — espionage, opium wars, million-dollar leaves and the odd rituals nobody tells over scones.",
  },
  {
    name: "Health, Wellness & Food Pairings",
    slug: "health-wellness-and-food-pairings",
    color: "#8a6a2a",
    title: "Tea, Health, Wellness & Food Pairings — The Tea List",
    description:
      "Evidence-based reads on tea and health, caffeine, sleep and digestion, plus food-pairing notes for Australian and New Zealand tables.",
  },
];

const slugify = (s) =>
  s.toLowerCase().replace(/&/g, "and").replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

export const categorySlug = (name) =>
  CATEGORIES.find((c) => c.name === name)?.slug || slugify(name || "");

export const categoryPath = (name) => `/category/${categorySlug(name)}`;

export const categoryFromParam = (param) => {
  const decoded = decodeURIComponent(param || "");
  return (
    CATEGORIES.find((c) => c.slug === decoded) ||
    CATEGORIES.find((c) => c.name === decoded) ||
    CATEGORIES.find((c) => c.slug === slugify(decoded)) ||
    null
  );
};
